<template>
    <div class="main-bg">
        <Nav></Nav>
        <div class="content">
            <div class="contanier">
                <div class="top-box">
                    <div class="top-title">
                        <img class="icon" src="../../assets/course/study.png" />
                        我的学习
                    </div>
                    <div class="top-tabs">
                        <div class="tab-item"
                             :class="{ active: current === tab.value }"
                             v-for="(tab, index) in tabs"
                             :key="index"
                             @click="setCurrent(tab)">
                            {{ tab.name }}
                        </div>
                    </div>
                    <div class="top-status">
                        <el-radio-group v-model="currenStatus" @change="statusChange">
                            <el-radio :label="1">全部</el-radio>
                            <el-radio :label="2">已完成</el-radio>
                            <el-radio :label="3">未完成</el-radio>
                        </el-radio-group>
                      
                    </div>
                </div>
                <div class="list-box">
                    <template v-if="loading">
                        <skeleton-study></skeleton-study>
                    </template>
                    <template v-else-if="list.length > 0">

                        <course-item v-if="current === 'vod'"
                                     :list="list"></course-item>
                        <pkg-item v-if="current === 'pkg'"
                                  :list="list"></pkg-item>
                    </template>
                    <None type="white" v-else></None>
                    <div id="page" v-if="total > 10">
                        <el-pagination v-if="loading"
                                       @current-change="changepage"
                                       :page-size="pagination.size"
                                       background
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="total">
                        </el-pagination>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Nav from "@/components/nav.vue";
    import None from "@/components/training/none.vue";
    import CourseItem from "./components/course-item.vue";
    import PkgItem from "./components/pkg-item.vue";
    import SkeletonStudy from "./components/skeletonStudy.vue";
    export default {
        components: {
            Nav,
            None,
            CourseItem,
            PkgItem,
            SkeletonStudy,
        },
        data() {
            return {
                loading: false,
                list: [],
                total: null,
                pagination: {
                    page: 1,
                    size: 10,
                },
                current: "pkg",
                currenStatus: 1,
                status: [
                    {
                        name: "全部",
                        value: 1,
                    },
                    {
                        name: "已完成",
                        value: 2,
                    },
                    {
                        name: "未完成",
                        value: 3,
                    },
                ],
            };
        },
        watch: {
            //currenStatus() {
            //    this.resetData();
            //    this.getData();
            //},
            current() {
                this.resetData();
                this.getData();
            }
        },
        computed: {
            tabs() {
                let types = [
                    {
                        name: "必修项目",
                        value: "pkg",
                    },
                    {
                        name: "选修课",
                        value: "vod",
                    },
                    {
                        name: "培训班",
                        value: "class",
                    },
                ];
                return types;
            },
        },
        mounted() {

            this.getData();
        },
        methods: {
            statusChange(value) {
                debugger;
                this.currenStatus = value;
                this.resetData();
                this.getData();
            },
            resetData() {
                this.list = [];
                this.pagination.size = 10;
                this.pagination.page = 1;
            },
            changepage(item) {
                this.pagination.size = item.pageSize;
                this.pagination.page = item.currentPage;
                this.getData();
            },
            getData() {
                if (this.loading) {
                    return;
                }
                this.loading = true;

                this.getViewStudy();

            },
            getViewStudy() {
                this.loading = false;

                if (this.current === "vod") {
                    this.list = [
                        {
                            "id": 1,
                            "progress": 0,
                            "learnedCount": 0,
                            "isLearned": 0,
                            "title": "操作指南",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLB29sWmMcqW5XrmP6IibRZAmibyocfHtVnicEsicP3NavgrQAGGvQk9qWxhILwibT4ib4dJM/356",
                            "taskCount": 3
                        },
                        {
                            "id": 2,
                            "progress": 50,
                            "learnedCount": 2,
                            "isLearned": 0,
                            "title": "C#深度学习入门与实战",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAdmTbic5y5kwZmbP7TLa8A0iclQddeBk3UB4icEttskabIxLzhfYwl7dQjJ5wNQ7fFiac/356",
                            "taskCount": 4
                        },
                        {
                            "id": 3,
                            "progress": 100,
                            "learnedCount": 3,
                            "isLearned": 1,
                            "title": "MYSQL增删改查操作",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBhLOcxd2DWkjwWUXYvgZicLvU0S7gUWZM9m2RCbJbDvt3HViaG621wVcibfvmqk7NVGA/356",
                            "taskCount": 3

                        },
                        {
                            "id": 4,
                            "progress": 100,
                            "learnedCount": 5,
                            "isLearned": 1,
                            "title": "IOS+Swift零基础教程",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCoNyJwbmOLtEXr8PA0UrSlhBIeLNgvTfCcOSWJdwFrRtH6YWuib0ROeIdy84PlBeVs/356",
                            "taskCount": 5
                        },
                        {
                            "id": 5,
                            "progress": 100,
                            "learnedCount": 5,
                            "isLearned": 1,
                            "title": "k8s&doceker实战",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAKAFJw1ypsCtU5TKsic6yycex2ZQSknichF6IIR1G8MribmgxUN9OgdzAjOk3iaeXlfxg/356",
                            "taskCount": 5
                        },
                        {
                            "id": 6,
                            "progress": 100,
                            "learnedCount": 5,
                            "isLearned": 1,
                            "title": "C++基本介绍",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCUDBxXtW69z3jZ2zSGnytzAMfQXzw8UNibO2taIx1OpdBUwiaFJ1Lvyurnpg4arh2J0/356",
                            "taskCount": 5
                        },
                        {
                            "id": 7,
                            "progress": 80,
                            "learnedCount": 4,
                            "isLearned": 0,
                            "title": "小程序应用与开发",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAkEriceW0qbqibMat9Jj2oiao7wSLoGtEjQvXgiaWyNteJ1FN1uDDKnDric4ticoickUz6OE/356",
                            "taskCount": 5
                        }

                    ];
                    //Api.Courses(this.pagination)
                    //  .then((res) => {
                    //    this.loading = false;
                    //    this.list = res.data.data;
                    //    this.total = res.data.total;
                    //  })
                    //  .catch((e) => {
                    //    this.loading = false;
                    //    this.$message.error(e.message);
                    //  });
                } else if (this.current === "pkg") {
                    this.list = [
                        {
                            "id": 1,
                            "progress": 0,
                            "learnedCount": 0,
                            "isLearned": 0,
                            "title": "操作指南",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLB29sWmMcqW5XrmP6IibRZAmibyocfHtVnicEsicP3NavgrQAGGvQk9qWxhILwibT4ib4dJM/356",
                            "courseCount": 3
                        },
                        {
                            "id": 2,
                            "progress": 50,
                            "learnedCount": 2,
                            "isLearned": 0,
                            "title": "C#深度学习入门与实战",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAdmTbic5y5kwZmbP7TLa8A0iclQddeBk3UB4icEttskabIxLzhfYwl7dQjJ5wNQ7fFiac/356",
                            "courseCount": 4
                        },
                        {
                            "id": 3,
                            "progress": 100,
                            "learnedCount": 3,
                            "isLearned": 1,
                            "title": "MYSQL增删改查操作",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBhLOcxd2DWkjwWUXYvgZicLvU0S7gUWZM9m2RCbJbDvt3HViaG621wVcibfvmqk7NVGA/356",
                            "courseCount": 3

                        },
                        {
                            "id": 4,
                            "progress": 100,
                            "learnedCount": 5,
                            "isLearned": 1,
                            "title": "IOS+Swift零基础教程",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCoNyJwbmOLtEXr8PA0UrSlhBIeLNgvTfCcOSWJdwFrRtH6YWuib0ROeIdy84PlBeVs/356",
                            "courseCount": 5
                        },
                        {
                            "id": 5,
                            "progress": 100,
                            "learnedCount": 5,
                            "isLearned": 1,
                            "title": "k8s&doceker实战",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAKAFJw1ypsCtU5TKsic6yycex2ZQSknichF6IIR1G8MribmgxUN9OgdzAjOk3iaeXlfxg/356",
                            "courseCount": 5
                        },
                        {
                            "id": 6,
                            "progress": 100,
                            "learnedCount": 5,
                            "isLearned": 1,
                            "title": "C++基本介绍",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCUDBxXtW69z3jZ2zSGnytzAMfQXzw8UNibO2taIx1OpdBUwiaFJ1Lvyurnpg4arh2J0/356",
                            "courseCount": 5
                        },
                        {
                            "id": 7,
                            "progress": 80,
                            "learnedCount": 4,
                            "isLearned": 0,
                            "title": "小程序应用与开发",
                            "thumb": "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAkEriceW0qbqibMat9Jj2oiao7wSLoGtEjQvXgiaWyNteJ1FN1uDDKnDric4ticoickUz6OE/356",
                            "courseCount": 5
                        }

                    ];
                    //Api.pkg(this.pagination)
                    //  .then((res) => {
                    //    this.loading = false;
                    //    this.list = res.items;
                    //    this.total = res.totalCount;
                    //  })
                    //  .catch((e) => {
                    //    this.loading = false;
                    //    this.$message.error(e.message);
                    //  });
                }

            },

            setCurrent(tab) {
                this.current = tab.value;
            },
        },
    };
</script>
<style lang="scss" scoped>
    .main-bg {
        background-image: url("../../assets/home/backougnd.png");
        background-size: cover;
        overflow-x: hidden;

        .content {
            padding-top: 86px;
            width: 100%;
            float: left;
            height: 100%;


            .contanier {
                width: 1200px;
                min-height: 500px;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                padding-top: 42px;

                .top-box {
                    width: 100%;
                  
                    background: #ffffff;
                    border-radius: 8px;
                    box-sizing: border-box;
                    padding: 30px;

                    .top-title {
                        width: 100%;
                        height: 36px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        font-size: 24px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 36px;

                        .icon {
                            width: 36px;
                            height: 36px;
                            margin-right: 10px;
                        }
                    }

                    .top-tabs {
                        width: 100%;
                        height: auto;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-top: 24px;

                        .tab-item {
                            width: auto;
                            height: auto;
                            font-size: 18px;
                            font-weight: 400;
                            color: #333333;
                            box-sizing: border-box;
                            padding-bottom: 13px;
                            border-bottom: 4px solid #fff;
                            margin-right: 60px;
                            cursor: pointer;

                            &:hover {
                                font-weight: 600;
                                color: #3ca7fa;
                                opacity: 0.8;
                            }

                            &.active {
                                font-weight: 600;
                                color: #3ca7fa;
                                border-bottom: 4px solid #3ca7fa;
                            }
                        }
                    }

                    .top-status {
                        width: 100%;
                        height: auto;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-top: 30px;

                        .item-radio {
                            display: flex;
                            height: 14px;
                            flex-direction: row;
                            align-items: center;
                            margin-right: 40px;

                            input {
                                width: 14px;
                                height: 14px;
                                margin-right: 10px;
                            }

                            label {
                                font-size: 14px;
                                font-weight: 400;
                                color: #666666;
                                line-height: 14px;
                                margin-right: 30px;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .list-box {
                    width: 100%;
                    height: auto;
                    background: #ffffff;
                    border-radius: 8px;
                    box-sizing: border-box;
                    padding: 30px;
                    margin-top: 30px;

                    #page {
                        width: 100%;
                        float: left;
                        height: auto;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        margin-top: 50px;
                    }

                    .item {
                        width: 100%;
                        height: 120px;
                        display: flex;
                        flex-direction: row;
                        margin-bottom: 30px;

                        .left-item {
                            width: 200px;
                            height: 120px;
                            border-radius: 4px;
                            overflow: hidden;
                            position: relative;
                            margin-right: 30px;
                            background: #f0f0f8;

                            .icon {
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                width: 66px;
                                height: 30px;
                                background: #ff4d4f;
                                border-radius: 4px 0px 4px 0px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #ffffff;
                                line-height: 14px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }

                        .right-item {
                            flex: 1;
                            height: 120px;
                            margin-right: 30px;

                            .item-title {
                                width: 816px;
                                height: auto;
                                font-size: 16px;
                                font-weight: 600;
                                color: #333333;
                                line-height: 16px;
                                margin-top: 30px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }

                            .item-info {
                                width: 816px;
                                height: auto;
                                display: flex;
                                flex-direction: row;
                                margin-top: 35px;

                                .item-text {
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #666666;
                                    line-height: 14px;
                                    margin-right: 30px;
                                }

                                .item-progress {
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #ff4d4f;
                                    line-height: 14px;
                                    margin-right: 30px;
                                }
                            }
                        }

                        .button {
                            width: 104px;
                            height: 46px;
                            border-radius: 4px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #3ca7fa;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-top: 37px;

                            &.completed {
                                background: #f4fafe;
                            }

                            &.continue {
                                border: 1px solid #3ca7fa;
                                cursor: pointer;

                                &:hover {
                                    opacity: 0.8;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
